import React from 'react';
import styled from 'styled-components';
import Contact from '../components/Contact';
import SEOHead from '../components/SEOHead';

const ContactPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Codewave Technologies Limited - ICT Company Nairobi Kenya",
    "description": "Contact Codewave Technologies Limited for bulk SMS services, USSD solutions, SMS gateway, mobile payment integration, and telecom solutions in Kenya. Get a quote today.",
    "url": "https://www.codewave.co.ke/contact",
    "mainEntity": {
      "@type": "Organization",
      "name": "Codewave Technologies Limited",
      "telephone": "+254-XXX-XXX-XXX",
      "email": "info@codewave.co.ke",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressRegion": "Nairobi",
        "addressCountry": "KE"
      }
    }
  };

  return (
    <PageWrapper>
      <SEOHead
        title="Contact Codewave Technologies Limited - ICT Services Nairobi, Telecom Company Kenya"
        description="Contact Codewave Technologies Limited for affordable bulk SMS services in Kenya, best USSD service provider, SMS gateway for businesses, and mobile payment solutions. Get in touch with our team in Nairobi today."
        keywords="contact Codewave, ICT services Nairobi, telecom company Nairobi Kenya, bulk SMS Nairobi, USSD services Nairobi, SMS gateway Kenya, mobile payment solutions Kenya, API integration services Kenya, business communication solutions, enterprise messaging solutions, customer engagement platforms"
        url="https://www.codewave.co.ke/contact"
        canonical="https://www.codewave.co.ke/contact"
        structuredData={structuredData}
      />
      <Contact />
    </PageWrapper>
  );
};

// Styled Components
const PageWrapper = styled.div`
  margin-top: 10vh;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fb 0%, #f1f4f9 100%);
`;

export default ContactPage;
